const env = window.env || {};

export const authAudience = env.AUTH_AUDIENCE || 'https://api.myhealthchampion.com';
export const authClientId = env.AUTH_CLIENTID ;
export const authDomain = env.AUTH_DOMAIN || 'id.calciumhealth.com';
export const authRealm = env.AUTH_REALM || 'Username-Password-Authentication';
export const authResponseType = env.AUTH_RESPONSE_TYPE || 'id_token token';
export const authScope = env.AUTH_SCOPE || 'openid email profile prod.profiles prod.healthdata';

export const appInsightsKey = '59c3a16a-4ca9-4559-9202-70f3acc9c061';

export const profilesApiRoot = env.API_ROOT_PROFILES || 'https://profiles.api.calciumhealth.com';
export const healthDataApiRoot = env.API_ROOT_HEALTH || 'https://healthdata.api.calciumhealth.com';
export const mobileAppRoot = env.MOBILE_APP_ROOT || 'hcapp-internal://';
export const healthIndexRoot = env.HEALTH_INDEX_ROOT || 'https://apim-micro-services-prod.azure-api.net/Healthindex-API/V1';
export const deleteProfileRoot = env.DELETE_PROFILE_ROOT || 'https://apim-micro-services-prod.azure-api.net/delete-profile-api/V1/api';
export const abTestingRoot = env.AB_TESTING_ROOT || 'https://apim-micro-services-prod.azure-api.net/AbTesting-API/V1';
export const healthCareProfileRoot = env.HEALTH_CARE_PROFILE_ROOT || 'https://apim-micro-services-prod.azure-api.net/HealthcareProfile-API/V1';
export const microserviceHFDataApiRoot = env.APP_API_ROOT_HFDATA || 'https://apim-micro-services-prod.azure-api.net/HFData-API/V1';
export const profileViewDataRoot = env.PROFILE_VIEW_DATA_ROOT || 'https://apim-micro-services-prod.azure-api.net/profileviewdata-API/V1';
export const deviceManagerRoot = env.DEVICE_MANAGER_ROOT || 'https://apim-micro-services-prod.azure-api.net/devicemanager-API/V1';
export const organizationRoot = env.ORGANIZATION_ROOT || 'https://apim-micro-services-prod.azure-api.net/organization/V1';
export const acsAdapterRoot = env.ACS_ADAPTER_ROOT || 'https://apim-micro-services-prod.azure-api.net/ACSAdapter-api/V1';
export const goalServiceRoot = env.GOAL_SERVICE_ROOT || 'https://apim-micro-services-prod.azure-api.net/goal-API/V1';


export const epicLogin = env.EPIC_LOGIN;
export const epicToken = env.EPIC_TOKEN;
export const epicRefreshToken = env.EPIC_REFRESH_TOKEN;
export const epicDocuments = env.EPIC_DOCUMENTS;

export const idme_redirectionurl = env.Idme_redirectionurl || "hcapp-internal://idmesuccess";
export const idme_verificationurl = env.Idme_verificationurl ;
export const studioRoot = env.STUDIO_API || 'https://hc-pbuilder-api-prod.azurewebsites.net/';

export const ehrUrl = 'https://admin.kstinfotech.com/get_all_ehr';


export const feedbackEmail = 'feedback@calciumhealth.com';
export const privacyEmail = 'privacy@calciumhealth.com';
export const supportEmail = 'support@calciumhealth.com';

export const syncAgainLimitMinutes = parseConfigInt(env.SYNC_AGAIN_LIMIT_MINUTES, 60);
export const identityRefreshMinutes = parseConfigInt(env.IDENTITY_REFRESH_MINUTES, 60);

export const sendAgainVerificationCodeLimitSeconds = parseConfigInt(env.SEND_AGAIN_VERIFICATION_CODE_LIMIT_SECONDS, 60);

export const buildVersion = window.WEB_APP_VERSION || '';

export const branchKey = env.BRANCH_KEY || 'key_live_npSqO3OPL7tWJlF8eFOIidaawDcNwprp';

export const helpScoutBeaconId = env.HELPSCOUT_BEACON_ID || '4664fd34-4c6a-46ba-b8f5-49e3fca6bc3d';

export const marketPlaceUrl = env.MARKET_PLACE_URL || 'https://marketplace.calciumhealth.com/compatible-devices?utm_source=app&utm_medium=link&utm_campaign=member';

export const privacyPolicyUrl = env.PRIVACY_POLICY_URL || 'https://calciumhealth.com/privacy-policy/';
export const termsAndConditionsUrl = env.TERMS_AND_CONDITIONS_URL || 'https://calciumhealth.com/terms-and-conditions/';
export const supportUrl = env.SUPPORT_URL || 'https://support.calciumhealth.com/';

export const calciumWebUrl = env.CALCIUMWEB_URL || 'https://calciumhealth.com/';

export const tempEHRCondition = parseConfigInt(env.TEMP_EHR_CONDITION_NUMERIC, 5);

export const defaultDashboardCirclePreferences = env.DEFAULT_DASHBOARD_CIRCLE_PREFERENCES || 'bloodPressure,medication,exercise,temperature,steps';
export const defaultMedicationTimingPreferences = '08:00,17:00';

export const weeklyDatePickerFutureDays = 90;
export const noImmunizationPathwayId = env.NO_IMMUNIZATION_PATHWAY_ID || '';

export const paymentGatewayRoot = env.PAYMENT_GATEWAY_ROOT || 'https://payment.calciumhealth.com';

export const iasPrivacyNoticeUrl = env.IAS_PRIVACY_URL || 'https://calciumhealth.com/ias-privacy-and-security-notice-tefca/';

export const fileTypesAllowed = '.jpg,.jpeg,.png';
export const fileMaxSizeKB = 2048;
export const fileResizeWidth = 780;
export const fileResizeHeight = 420;
export const fileUploadLimit = 5;
export const fileMaxTextLength = 50;

function parseConfigInt(config, defaultValue) {
  var result = parseInt(config);
  return isNaN(result) ? defaultValue : result;
}
